import React, { FC } from 'react';
import { Trans } from 'react-i18next';

import { Grid, Typography } from '@mui/material';

import { Dialog, DialogProps } from 'components';
import DialogFooterButtons from 'components/dialog/DialogFooterButtons';

export interface TransferErrorDialogProps extends DialogProps {
  message?: string | null;
}

const TransferErrorDialog: FC<TransferErrorDialogProps> = ({
  open,
  onClose,
  message,
  title,
  ...props
}) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      title={title}
      open={open}
      onClose={handleClose}
      actions={
        <DialogFooterButtons
          disableDialogButtons={true}
          cancelText="COMMON.ALRIGHT"
          cancelClick={handleClose}
        />
      }
      {...props}
    >
      <Grid container spacing={2}>
        <Grid item>
          <Typography variant="body2">{message ? <Trans i18nKey={message} /> : null}</Typography>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default TransferErrorDialog;
